import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ITooltipAngularComp } from 'ag-grid-angular';

@Component({
  standalone: false,
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrl: './custom-tooltip.component.scss',
})
export class CustomTooltipComponent implements ITooltipAngularComp {
  params!: any;
  headerToolip: string = '';
  private sanitizer: DomSanitizer = inject(DomSanitizer);
  constructor() {}

  agInit(params: any): void {
    this.params = params;
    this.headerToolip = params.colDef.tooltipComponentParams || '';
  }

  changeAsteriskStyle(text: string): SafeHtml {
    const escapedText = text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const html = escapedText.replace(/\*/g, '<span style="color:red">*</span>');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
